import {View, Text, StyleSheet} from "react-native";
import React from "react";

function Account({navigation}) {
    return (
        <View style={styles.container}>
            <Text>Account</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default Account;
